import axios from "axios";
import { SysParam } from "./SysParamsTypes";

const API_URL = '/pcnt/param';

// Получить параметры
export async function getParams(): Promise<SysParam[]> {
  const res = await axios.get<SysParam[]>(API_URL);
  return res.data.filter(param => param.enabled);
}

// Обновить параметр
export async function updateParam(id: number, data: { value: { value: any } }): Promise<void> {
  await axios.patch(`${API_URL}/${id}/`, data, );
}
